import { ActionIcon, Badge, Button, Skeleton } from '@mantine/core';
import React from 'react';
import classes from './style.module.css';
import { IconPlus } from '@tabler/icons-react';
import { themeColors } from '@/theme/colors';
import { IconCircleX } from '@tabler/icons';
import { IUsePopUpUI, PopUpUI } from '@components/UI/PopUp';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@hooks/redux/redux';
import { useRestrictRoomsByRoles } from '@/containers/pages/filials/edit/components/tabs/security/components/restrict-rooms-by-roles/useRestrictRoomsByRoles';
import { RulesRestrictions } from '@/containers/pages/filials/edit/components/tabs/security/components/restrict-rooms-by-roles/components/RulesRestrictions';

const RulesSettingsPopUpTrigger = (props: IUsePopUpUI) => {
  const { setIsOpen } = props;
  const { t } = useTranslation();

  const handleOpen = () => setIsOpen(true);

  return (
    <Button
      className={classes.addException}
      classNames={{
        inner: classes.addExceptionInner,
        label: classes.addExceptionLabel
      }}
      size="sm"
      variant="outline"
      rightSection={<IconPlus color={themeColors.brandGray[0]} />}
      onClick={handleOpen}
    >
      {t('RestrictRoomsByRoles.addRole')}
    </Button>
  );
};

export const RestrictRoomsByRoles = () => {
  const { filial } = useAppSelector((state) => state.filials);
  const { t } = useTranslation();
  const [settings, isLoading, loadSettings, deleteRule] = useRestrictRoomsByRoles(filial?.Id);

  return (
    <div className={classes.container}>
      <div className={classes.title}>{t('RestrictRoomsByRoles.title')}</div>
      {isLoading && (
        <>
          <Skeleton height={20} radius="sm" width={200} />
          <Skeleton height={20} radius="sm" width={200} />
          <Skeleton height={20} radius="sm" width={200} />
          <Skeleton height={30} mt={1} radius="sm" />
          <Skeleton height={30} mt={1} radius="sm" />
          <Skeleton height={30} mt={1} radius="sm" />
        </>
      )}
      {!isLoading && (
        <div className={classes.body}>
          <PopUpUI
            mobileSize="100%"
            desktopPosition="right-start"
            trigger={RulesSettingsPopUpTrigger}
          >
            {({ isOpen, setIsOpen }) => (
              <RulesRestrictions
                isOpen={isOpen}
                onSuccess={loadSettings}
                setIsOpen={setIsOpen}
                settings={settings}
              />
            )}
          </PopUpUI>
          <div className={classes.wrapperBadge}>
            {settings?.Roles.map((Role, index) => (
              <Badge
                className={classes.badge}
                key={index}
                variant="outline"
                rightSection={
                  <ActionIcon className={classes.iconWrapper} onClick={() => deleteRule(Role.Id)}>
                    <IconCircleX color="#667085" />
                  </ActionIcon>
                }
              >
                {Role.Name}
              </Badge>
            ))}
          </div>
          <div className={classes.description}>{t('RestrictRoomsByRoles.description')}</div>
        </div>
      )}
    </div>
  );
};
